import { MenuItem, Button, IconButton } from "@mui/material";
import { LocationContext } from "./pageChooser";
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import SearchIcon from '@mui/icons-material/Search';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { FavouritesContext } from "../favourites/favouritesProvider";
import { useAnalytics } from "../firebase/firebase";


export const ToggleSearchAlbumButton = () => {
    const { track } = useAnalytics();
    const { subPage, setSubPage } = useContextWithGuard(LocationContext, "LocationContext");

    return (
        (subPage == "search")
            ?
            <>
                <IconButton
                    size="large"
                    edge="start"
                    aria-label="settings"
                    sx={{
                        mr: 2,
                        border: 'none !important',

                    }}
                    aria-haspopup="true"
                    onClick={() => {
                        setSubPage("album");
                        track("favourites.show");
                    }}
                    title="go to favourites"
                    color="primary"
                >
                    <FavoriteIcon />
                </IconButton>
            </>
            :
            <IconButton
                size="large"
                edge="start"
                aria-label="settings"
                sx={{
                    mr: 2,
                    border: 'none !important',
                }}
                aria-haspopup="true"
                onClick={() => {
                    setSubPage("search");
                    track("favourites.hide");
                }}
                title="go to search"
                color="primary"
            >
                <SearchIcon />
            </IconButton>
    )
} 